import colorAxis from './colorAxis8Level'
const dataDisplayOptions = [
  {
    label: 'Public Indicators',
    options: [
      {
        value: 'forecast_level',
        tagKey: 'forecast_level',
        tagValue: 'data_value',
        label: 'Incidense Rate',
        colorAxis: colorAxis,
        mapTitle: 'US COVID Incidence',
        mapSubTitle: undefined,
        indicatorName: 'Forecasts',
        legend: {
          enabled: false,
          title: {
            text: 'US COVID Incidence',
          },
        },
      },
    ],
  },
]

export default dataDisplayOptions
